// KycController
app.controller('KycController', ['$scope', '$location', 'WdHttpService', 'sessionService', 'config', 'analyticsService',
    function ($scope, $location, WdHttpService, sessionService, config, analyticsService) {

        $scope.firstName = undefined;
        $scope.lastName = undefined;
        $scope.email = undefined;
        $scope.mobile = undefined;
        $scope.address = undefined;
        $scope.city = undefined;
        $scope.state = undefined;
        $scope.pincode = undefined;
        $scope.brokerName = undefined;
        $scope.clientCode = undefined;
        $scope.panCard = undefined;
        $scope.birthdate = undefined;
        $scope.brokerDisplayName = undefined;
        $scope.userConsentField = false;
        $scope.isPEP = false;
        $scope.isNRI = false;
        $scope.clientCodeRegex = /^\w+$/;

        // Init 
        $scope.init = async function () {
            await $scope.fetchAdviserSiteDetails();
            if ($location.search().fund) {
                $scope.fundName = $location.search().fund;
                sessionService.set('fundName', $scope.fundName);
            } else {
                $scope.fundName = sessionService.get('fundName');
            }
            if (!$scope.fundName) {
                await $scope.showErrorPopup('Basket name is missing from your broker login response.', () => window.location.href = '/');
                return;
            }
            if (!sessionService.isLoggedIn()) {
                $scope.showErrorPopup('Session Timed Out. Please login again.', () => window.location.href = '/');
                return;
            }

            $scope.showPageLoader();


            // Get User DDB Profile to check whether he is subscribed or invested in this fund
            $scope.isUserSubscribed = await WdHttpService._is_user_invested($scope.fundName, sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL");
            if ($scope.isUserSubscribed) {
                $scope.hidePageLoader();
                $scope.showErrorPopup("You are already Invested, you will be redirected to your Portfolio dashboard", () => window.location.href = 'my-portfolio', false);
                $scope.$evalAsync();
                return;
            }

            var data = {
                q: "fundName:" + $scope.fundName,
                f: "web_admin:" + $scope.webadminName
            }
            // Search the fund and get the amount of fee to be paid.
            await WdHttpService._get_funds(data).then(async function (response) {
                if (response.status == 200) {
                    // This if condition is coded due to a server side bug to be fixed yet.
                    if (response.data.Items.length == 1) {
                        $scope.fund_details = response.data.Items[0];
                    } else if (response.data.Items.length > 1) {
                        response.data.Items.forEach(fund => {
                            if (fund.fundName == $scope.fundName) {
                                $scope.fund_details = fund;
                            }
                        });
                    } else {
                        $scope.fund_details = undefined;
                        $scope.showErrorPopup('This fund seems to have closed now, could not fetch fund details', () => window.location.href = '/');
                        return;
                    }
                    await WdHttpService._check_advisory_fee($scope.fundName, $scope.fund_details.adviserUsername)
                        .then(response => {
                            $scope.advisoryFeeInfo = response;
                        }).catch(error => {
                            console.log(error);
                            $scope.advisoryFeeInfo = 'NA';
                        });
                    if ($scope.advisoryFeeInfo == 'PAID') {
                        if ($scope.fund_details.fee != 0) {
                            $scope.showErrorPopup("You are already Subscribed, You need to Invest ",
                                () => window.location.href = 'fund-details/' + $scope.fundName, false);
                            $scope.$evalAsync();
                            return;
                        }
                    }

                    if ($scope.fund_details.adviserUsername in config.ADVISERSMETADATA) {
                        if ('kycFetchApi' in config.ADVISERSMETADATA[$scope.fund_details.adviserUsername]) {
                            $scope.showKraForm = config.ADVISERSMETADATA[$scope.fund_details.adviserUsername].kycFetchApi;
                        } else {
                            $scope.showKraForm = false;
                        }
                    } else {
                        $scope.showKraForm = false;
                    }
                    $scope.isAdviserResearchAnalyst = $scope.fund_details.wealthBasketType == 'RA' ? true : false;
                }
            });

            $scope.userRiskValue = await WdHttpService._get_user_risk_profile(false);
            sessionService.set('adviser-type', $scope.isAdviserResearchAnalyst + "");
            sessionService.set('user-risk', $scope.userRiskValue);
            sessionService.set('fund-risk', $scope.fund_details.risk);
            if ($scope.isAdviserResearchAnalyst) {
                await $scope.checkAdvisoryAgreementAndRedirect();
                return;
            }
            await $scope.decideFieldsToShow();
            if ($scope.isAdviserResearchAnalyst == false && $scope.isKycProfileComplete) {
                if (!$scope.userRiskValue) {
                    $location.url('/risk-profile?next=agreement&adviserUsername=' + $scope.fund_details.adviserUsername + '&fundName=' + $scope.fund_details.fundName);
                } else {
                    await $scope.checkAdvisoryAgreementAndRedirect();
                }
            }

            $scope.$evalAsync();
            $scope.hidePageLoader();
        }

        $scope.checkAdvisoryAgreementAndRedirect = async function () {
            $scope.analystAgreementStatus = await WdHttpService._get_user_adviser_analyst_agreement_status($scope.fund_details.adviserUsername);
            if ($scope.analystAgreementStatus != "SIGNED") {
                $location.url('/adviser-agreement/' + $scope.fund_details.adviserUsername + '/' + $scope.fund_details.fundName);
            } else if ($scope.analystAgreementStatus == "INPROGRESS") {
                let agreementStatus = await WdHttpService._get_agreement_esign_status($scope.fund_details.adviserUsername);
                var redirectUrl = agreementStatus.signUrl;
                $scope.showErrorPopup("Your agreement signing with adviser is pending, redirecting you to sign the agreement.", () => window.location.href = redirectUrl);
            } else {
                sessionService.remove('adviser-type');
                sessionService.remove('user-risk');
                sessionService.remove('fund-risk');
                $location.url('/subscribe/' + $scope.fund_details.adviserUsername + '/' + $scope.fund_details.fundName);
            }
            $scope.$evalAsync();
        }

        $scope.popup1 = {
            opened: false
        };

        $scope.dateOptions = {
            formatYear: 'yyyy',
            maxDate: setMaxDate(),
            initDate: setMaxDate()
        };

        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy', 'shortDate'];
        $scope.format = $scope.formats[2];
        $scope.altInputFormats = ['d!/M!/yyyy', 'd!-M!-yyyy', 'dd/MM/yyyy', 'dd-MM-yyyy'];

        $scope.decideFieldsToShow = async function () {
            var profileData = await WdHttpService._get_dynamodb_user_profile();

            var investorName = profileData.name.split(' ');
            $scope.userProfile = {};
            $scope.userProfile.firstName = investorName[0] ? investorName[0] : undefined;
            $scope.userProfile.lastName = investorName[1] ? investorName[1] : undefined;
            $scope.userProfile.email = profileData.email;
            $scope.userProfile.mobile = profileData.phoneNumber ? profileData.phoneNumber.replace('+91', '') : undefined;
            $scope.userProfile.address = profileData.address['address1'];
            $scope.userProfile.city = profileData.address['city'];
            $scope.userProfile.stateField = profileData.address['state'];
            $scope.userProfile.pincode = profileData.address['pincode'];
            $scope.userProfile.brokerName = profileData.brokerCompany;
            if ($scope.userProfile.brokerName) {
                if (config[$scope.userProfile.brokerName]) {
                    $scope.brokerDisplayName = config[$scope.userProfile.brokerName].brokerName ? config[$scope.userProfile.brokerName].brokerName : $scope.userProfile.brokerName;
                } else {
                    $scope.brokerDisplayName = $scope.userProfile.brokerName;
                }
            } else {
                $scope.showErrorPopup('There seems to be an issue with your user onboarding - ErrorCode 51256. Kindly drop an email to support@wealthdesk.in with the screenshot of this message or the ErrorCode', undefined, true, 'Some Error Occured');
            }
            $scope.userProfile.clientCode = profileData.clientCode;
            $scope.userProfile.panCard = profileData.panCard;

            var tempDate;
            tempDate = profileData.dateOfBirth
            if (isNaN(tempDate)) {
                if (tempDate) {
                    var dateArr = tempDate.split('-');
                    tempDate = new Date(dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0] + 'T00:00');
                }
            } else if (!isNaN(tempDate) && tempDate) {
                tempDate = new Date(tempDate);
            } else
                tempDate = undefined;
            $scope.userProfile.birthdate = tempDate;
            $scope.isFormSet = true;
            $scope.isKycProfileComplete = checkProfile($scope.userProfile);
            $scope.$evalAsync();
        }

        function checkProfile(profileData) {
            for (const key in profileData) {
                if (profileData.hasOwnProperty(key)) {
                    if (!profileData[key] && key != 'clientCode') {
                        return false;
                    } else if (key == 'clientCode' && $scope.isOfflineBroker && !profileData[key]) {
                        return false;
                    }
                }
            }
            return true;

        }

        function setMaxDate() {
            // Allow only 18 years back date in DOB field
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear() - 18;
            if (dd < 10) {
                dd = '0' + dd
            }
            if (mm < 10) {
                mm = '0' + mm
            }
            today = yyyy + '-' + mm + '-' + dd;
            // return today;
            return new Date(yyyy, mm - 1, dd);
            // document.getElementById("birthdateField").setAttribute("max", today);
        }

        $scope.fetchKraKycDetails = async function (kraKycForm) {
            if (kraKycForm.$invalid) {
                return;
            }

            $scope.showPageLoader();
            await WdHttpService._fetch_kra_data($scope.fund_details.adviserUsername, kraKycForm.panCard.$modelValue, kraKycForm.birthdate.$modelValue)
                .then(response => {
                    $scope.userProfile.firstName = response.firstName;
                    $scope.userProfile.lastName = response.lastName;
                    $scope.userProfile.email = response.email;
                    $scope.userProfile.mobile = response.phoneNumber.substr(response.phoneNumber.length - 10);
                    $scope.userProfile.address = (response.address.add1 + ' ' + response.address.add2 + ' ' + response.address.add3).trim();
                    $scope.userProfile.city = response.address.city;
                    $scope.userProfile.stateField = $scope.stateList.includes(response.address.state.toUpperCase()) ? response.address.state.toUpperCase() : 'OTHERS';
                    $scope.userProfile.pincode = parseInt(response.address.pincode);

                    setTimeout(() => {
                        $scope.kraDataFetched = true;
                        $scope.$evalAsync();
                    }, 1000);

                    $scope.showKraForm = false;
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.kraDataFetched = false;
                    $scope.showKraForm = false;
                    $scope.$evalAsync();
                    $scope.hidePageLoader();
                })
        }

        $scope.submitKYCForm = async function (form) {
            $scope.submitted = true;
            var newChanges = {}
            if (form.$dirty && form.$valid && !form.$pristine) {
                newChanges['firstName'] = form.firstName.$modelValue;
                newChanges['lastName'] = form.lastName.$modelValue;
                newChanges['email'] = form.email.$modelValue;
                newChanges['phoneNumber'] = '+91' + form.mobile.$modelValue;
                var dob = new Date(form.birthdate.$modelValue);
                newChanges['dateOfBirth'] = (dob.getDate() < 10 ? '0' : '') + dob.getDate() + "-" + (dob.getMonth() < 9 ? '0' : '') + (dob.getMonth() + 1) + "-" + dob.getFullYear();
                newChanges['address'] = {};
                newChanges['address']['address1'] = form.address.$modelValue;
                newChanges['address']['state'] = form.state.$modelValue;
                newChanges['address']['city'] = form.city.$modelValue;
                newChanges['address']['pincode'] = form.pincode.$modelValue;
                newChanges['brokerName'] = $scope.userProfile.brokerName;
                newChanges['clientCode'] = form.clientCode.$modelValue ? form.clientCode.$modelValue : '';
                newChanges['panCard'] = form.panCard.$modelValue;
                newChanges['isNRI'] = !form.isNRI.$modelValue;
                newChanges['isPEP'] = !form.isPEP.$modelValue;
                $scope.update_user_kyc_data(newChanges);
            } else if (form.$dirty && form.$invalid && !form.$pristine) {
                $scope.showErrorPopup('Seems like you have missed some fields.');
            } else {
                $location.url('/risk-profile?next=agreement&adviserUsername=' + $scope.fund_details.adviserUsername + '&fundName=' + $scope.fund_details.fundName);
                $scope.$evalAsync();
            }
        }

        $scope.setForm = function (form) {
            $scope.riaKyc = form;
        }

        $scope.update_user_kyc_data = async function (data) {
            $scope.showLoading("#kycSubmitButton");
            await WdHttpService._post_user_kyc_profile(data)
                .then(async response => {
                    var eventData = {
                        'fundName': $scope.fund_details.fundName.toLowerCase(),
                        'adviserUsername': $scope.fund_details.adviserUsername.toLowerCase()
                    };
                    await analyticsService._push_custom_event_data_to_datalayer('kyc-completed', eventData);

                    if (!$scope.userRiskValue)
                        $location.url('/risk-profile?next=agreement&adviserUsername=' + $scope.fund_details.adviserUsername + '&fundName=' + $scope.fund_details.fundName);
                    else
                        $location.url('/adviser-agreement/' + $scope.fund_details.adviserUsername + '/' + $scope.fund_details.fundName);

                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                });
            $scope.stopLoading("#kycSubmitButton");
        }

        $scope.stateList = ["Punjab", "Himachal Pradesh", "Jammu and Kashmir", "Chandigarh",
            "Uttarakhand", "Haryana", "Delhi", "Rajasthan", "Uttar Pradesh", "Bihar", "Sikkim",
            "Arunachal Pradesh", "Assam", "Manipur", "Mizoram", "Tripura",
            "Meghalaya", "Nagaland", "West Bengal", "Jharkhand",
            "Odisha", "Chhattisgarh", "Madhya Pradesh", "Gujarat",
            "Daman and Diu", "Dadra and Nagar Haveli", "Maharashtra",
            "Andhra Pradesh", "Karnataka", "Goa", "Lakshadweep",
            "Kerala", "Tamil Nadu", "Puducherry", "Andaman and Nicobar Islands", "Others", "Telangana"
        ].map(state => state.toUpperCase());

        $scope.countryList = ["Albania", "Aland Islands", "Afghanistan", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua And Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
            "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia And Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic",
            "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic Of The", "Cook Islands", "Costa Rica", "Cote D'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador",
            "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland",
            "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island And Mcdonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic Of", "Iraq", "Ireland", "Isle Of Man", "Israel",
            "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic Of", "Korea, Republic Of", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg",
            "Macao", "Macedonia, The Former Yugoslav Republic Of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States Of", "Moldova, Republic Of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique",
            "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru",
            "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts And Nevis", "Saint Lucia", "Saint Pierre And Miquelon", "Saint Vincent And The Grenadines", "Samoa", "San Marino", "Sao Tome And Principe", "Saudi Arabia", "Senegal",
            "Serbia And Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia And The South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard And Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province Of China",
            "Tajikistan", "Tanzania, United Republic Of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad And Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks And Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan",
            "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis And Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Côte D'ivoire", "Korea,Democratic People'sRepublicOf", "Lao People's Democratic Republic"
        ].map(state => state.toUpperCase());
    }
]);